export default __webpack_public_path__ + "static/media/financialLife.68d42d48.jpeg";